import React, {useEffect, useState, Fragment} from "react";
import {useParams} from "react-router-dom";
import {
    Table,
    Image,
    Button,
    Pagination,
    Drawer,
    Form,
    Row,
    Col,
    Input,
    Card,
    Radio,
    PageHeader,
    Statistic,
    Modal,
    Select,
    notification,
} from "antd";
import {Dropdown} from "rsuite";
import moment from "moment";
import DetailModal from "../components/Detail";
import PlansModal from "../components/Plans";
import Extramin from "../components/Extramin";
import AddPackage from "../components/AddPackage";
import BulkAddPackage from "../components/BulkAddPackage";
import styled, { createGlobalStyle } from 'styled-components';
import {
    IconListDetails,
    IconPlusMinus,
    IconCreditCardPay,
    IconTrash,
    IconCalendarEvent,
    IconBrandPaypal,
    IconBrandStripe,
    IconEdit,
    IconUserCircle,
} from '@tabler/icons-react';
import Subscription from "../components/subscription";
import {Flex} from "@mantine/core";
//import StudentExcel from "./StudentExcel";
import CreditStatus from "../components/CreditStatus";
import Loader from "../atoms/Loader"
const axios = require("axios").default;

const Students = () => {
    const [students, setStudents] = useState([]); 
    const [studentDetail, setStudentDetail] = useState();
    const [totalRecord, setTotalRecord] = useState(0);
    let {pageNumber} = useParams();
    let {pagePer} = useParams();
    const [loading, setLoading] = useState(true);
    const [filters, setFilters] = useState();
    const [filterVisible, setFilterVisible] = useState(false);
    const [isPlanModalVisible, setIsPlanModalVisible] = useState(false);
    const [plan, setPlan] = useState(false);
    const [extramin, setExtramin] = useState(false);
    const [subscriptionList, setSubscriptionList] = useState("");
    const [payment, setPayment] = useState({});
    const [totalPaid, setTotalPaid] = useState(0);
    const [subscriptionModal, setSubscriptionModal] = useState(false)
    const [creditList, setCreditList] = useState(false)
    const [creditModal, setCreditModal] = useState(false)
    const [showPaid, setShowPaid] = useState(false)
    const [isBulkModalVisible, setIsBulkModalVisible] = useState(false)

    // Account edit modal
    const [accountModal, setAccountModal] = useState(false)
    const [accountStudent, setAccountStudent] = useState(null)
    const [accountEmail, setAccountEmail] = useState('')
    const [accountLoginType, setAccountLoginType] = useState('')
    const [accountPassword, setAccountPassword] = useState('')
    const [accountLoading, setAccountLoading] = useState(false)
    const [accountStatus, setAccountStatus] = useState(null)

    const [exportStudentsLoading, setExportStudentsLoading] = useState(false)
    const [exportPaymentsLoading, setExportPaymentsLoading] = useState(false)

    const columns = [
        {
            title: "",
            dataIndex: "image",
            key: "image",
            render: (text, record) => {
                const img = record.image;
                if (!img || img === 'noimage.jpg') {
                    return <IconUserCircle size={60} stroke={1} color="#ccc" />;
                }
                const src = img.startsWith('https')
                    ? img
                    : record.image_url.replace(/\/$/, '') + '/' + img;
                return <Image width={60} src={src} />;
            },
        },
        {
            title: "Name",
            dataIndex: "first_name",
            key: "first_name",
        },
        {
            title: "Last Name",
            dataIndex: "last_name",
            key: "last_name",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Country",
            dataIndex: "country",
            key: "country",
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
        },
        {
            title: "Membership",
            dataIndex: "social_type",
            key: "social_type",
            render: (text, record) => {
                if (record.social_type === 'google') return <span style={{ color: '#1677ff', fontWeight: 500 }}>Google</span>;
                if (record.social_type === 'apple') return <span style={{ color: '#fa8c16', fontWeight: 500 }}>Apple</span>;
                return <span style={{ color: '#52c41a', fontWeight: 500 }}>Normal</span>;
            },
        },
        {
            title: "Minutes",
            dataIndex: "remaining_minutes",
            key: "remaining_minutes",
        },
        {
            title: "Price",
            dataIndex: "price",
            key: "price",
            render: (text, record) => {
                return (
                    <>
                        {record.price ? (
                            <Statistic
                                title=""
                                prefix="₺"
                                value={record.price}
                                level={5}
                                valueStyle={{fontSize: "12px"}}
                            />
                        ) : null}
                    </>
                );
            },
        },
        {
            title: "Register Date",
            dataIndex: "created_at",
            key: "created_at",
            render: (text, record) => {
                return <>{moment(record.created_at).format("DD-MM-YYYY h:mm")}</>;
            },
        },
        {
            title: "",
            dataIndex: "",
            key: "",
            render: (text, record) => (
                <>
                    <Dropdowned title="Functions" placement="bottomEnd">
                        <Dropdown.Item onClick={() => openAccountModal(record)}
                                       icon={<IconEdit stroke={2} size={"16px"}/>}
                        >
                            Edit
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => showTestModal(record)}
                                       icon={<IconBrandPaypal stroke={2} size={"16px"}/>}
                        >
                            Add Subscription
                        </Dropdown.Item>

                        <Dropdown.Item onClick={() => showSubscriptionModal(record)}
                                       icon={<IconBrandStripe stroke={2} size={"16px"}/>}
                        >
                            Subscription
                        </Dropdown.Item>


                        <Dropdown.Item onClick={() => showDetailModal(record)}
                                       icon={<IconListDetails stroke={2} size={"16px"}/>}
                        >
                            Detail
                        </Dropdown.Item>
                        {record.price ? (
                            <Dropdown.Item onClick={() => showPlanModal(record)}
                                           icon={<IconCalendarEvent stroke={2} size={"16px"}/>}
                            >
                                Talks and Plan
                            </Dropdown.Item>
                        ) : (
                            <Dropdown.Item disabled
                                           icon={<IconCalendarEvent stroke={2} size={"16px"}/>}
                            >Talks and Plan</Dropdown.Item>
                        )}
                        <Dropdown.Item onClick={() => showExtraMinModal(record)}
                                       icon={<IconPlusMinus stroke={2} size={"16px"}/>}
                        >
                            Extra Minute Add
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => showCreditModal(record)}
                                       icon={<IconCreditCardPay stroke={2} size={"16px"}/>}
                        >
                            Credit Usage Status
                        </Dropdown.Item>

                        <Dropdown.Item
                            icon={<IconTrash stroke={2} size={"16px"}/>}
                        >
                            Delete
                        </Dropdown.Item>
                    </Dropdowned>
                </>
            ),
        },
    ];

    const getUserList = (pageNumber, filters = {}, per) => {
        let params = {
            pageNumber,
            filters,
            pagePer,
        };

        setLoading(true);
        axios.get(`student/list`, {params}).then(function (response) {
            setStudents(response.data.result.list);
            setTotalRecord(response.data.result.items.user_total);
            setTotalPaid(response.data.result.items.paid_total);
            return response;
        })
            .catch(function (error) {
                console.log(error)
            }).finally(() => {
            setLoading(false);
        })
    };

    useEffect(() => {
        console.log("Fetching user list for page number:", pageNumber);
        getUserList(pageNumber);
    }, [pageNumber]);

    const onUserPageChange = (pageNumber, pagePer) => {
        getUserList(pageNumber, filters, pagePer);
    };

    const handleFilter = async (filt) => {
        await setFilters(filt);
        await getUserList(pageNumber, filt, pagePer);
    };


    const showDetailModal = (detail) => {
        setStudentDetail(detail);
    };

    const showPlanModal = (detail) => {
        setPlan(detail);
    };

    const showExtraMinModal = (detail) => {
        setExtramin(detail);
    };

    const showCreditModal = (detail) => {
        setCreditList(detail);
        setCreditModal(true)
    }

    const showTestModal = (detail) => {
        setPayment(detail);
        setIsPlanModalVisible(true)
    }

    const statusToNumber = (statusStr) => {
        if (statusStr === 'Active') return 1;
        if (statusStr === 'Pasive') return 2;
        if (statusStr === 'Deleted') return 3;
        return 1;
    };

    const openAccountModal = (record) => {
        setAccountStudent(record);
        setAccountEmail(record.email || '');
        setAccountLoginType(record.social_type || 'normal');
        setAccountPassword('');
        setAccountStatus(statusToNumber(record.status));
        setAccountModal(true);
    };

    const handleAccountSave = async () => {
        setAccountLoading(true);
        try {
            await axios.post(`student/update-account/${accountStudent.user_no}`, {
                email: accountEmail,
                login_type: accountLoginType,
                password: accountPassword,
            });
            const originalStatus = statusToNumber(accountStudent.status);
            if (accountStatus !== originalStatus) {
                await axios.post(`student/update-status/${accountStudent.user_no}`, { status: accountStatus });
            }
            notification.success({ message: 'Account updated' });
            setAccountModal(false);
            getUserList(pageNumber);
        } catch (err) {
            notification.error({ message: err?.response?.data?.message || 'Something went wrong' });
        } finally {
            setAccountLoading(false);
        }
    };

const showSubscriptionModal = (detail) => {
        setSubscriptionList(detail);
        setSubscriptionModal(true)
    }

    const downloadExcel = (data, filename) => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    };

    const handleExportStudents = async () => {
        setExportStudentsLoading(true);
        try {
            const response = await axios.get('student/export/students', { responseType: 'blob' });
            downloadExcel(response.data, 'ogrenci-cikti-listesi.xlsx');
        } catch (err) {
            notification.error({ message: 'Excel oluşturulamadı' });
        } finally {
            setExportStudentsLoading(false);
        }
    };

    const handleExportPayments = async () => {
        setExportPaymentsLoading(true);
        try {
            const response = await axios.get('student/export/payments', { responseType: 'blob' });
            downloadExcel(response.data, 'odeme-yapanlar-listesi.xlsx');
        } catch (err) {
            notification.error({ message: 'Excel oluşturulamadı' });
        } finally {
            setExportPaymentsLoading(false);
        }
    };

    const showFilterDrawer = () => {
        setFilterVisible(true);
    };

    const onFilterClose = () => {
        setFilterVisible(false);
    };


    return (
        <>
            <GlobalStyle />
            <Drawer
                title="Detail Search"
                placement="right"
                onClose={onFilterClose}
                visible={filterVisible}
            >
                <Form
                    layout="vertical"
                    hideRequiredMark
                    name="exam_form"
                    labelAlign="left"
                    labelWrap
                    wrapperCol={{flex: 1}}
                    colon={true}
                    onFinish={handleFilter}
                >
                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item name={"first_name"} label="Name">
                                <Input placeholder="name"/>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item name="last_name" label="Last Name">
                                <Input placeholder="last_name"/>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item name="email" label="Email">
                                <Input placeholder="Email"/>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item name="country" label="Country">
                                <Input placeholder="Country"/>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row gutter={24}>
                        <Col span={12}>
                            <Form.Item name="status" label="Status">
                                <Radio.Group>
                                    <Radio value={1}>Active</Radio>
                                    <Radio value={2}>Passive</Radio>
                                    <Radio value={3}>Delete</Radio>
                                    <Radio value={4}>All</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>

                        <Col span={12}>
                            <Form.Item name="pay" label="Pay Status">
                                <Radio.Group>
                                    <Radio value={1}>Paid</Radio>
                                    <Radio value={2}>Not Pay</Radio>
                                    <Radio value={3}>All</Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Button type="primary" block htmlType="submit">
                        Ara
                    </Button>
                </Form>
            </Drawer>


            <PageHeader>
                <Row>
                    <Statistic
                        title="subscriber"
                        prefix=""
                        value={totalRecord}
                        style={{
                            margin: "0px 32px 0px -16px",
                        }}
                    />
                    <Statistic title="Paid" prefix="₺" value={totalPaid}/>
                </Row>
            </PageHeader>


            <Card
                type="inner"
                title={
                    <h1 className="h3 mb-3">
                        <strong>STUDENTS</strong> LIST ({totalRecord}){" "}
                    </h1>
                }
                extra={
                    <Flex
                        display={"flex"}
                        gap={"50px"}
                        align={"center"}
                    >
                        {/*<StudentExcel/>*/}

                        <Button
                            type="primary"
                            style={{backgroundColor: "#722ed1", border: "none"}}
                            loading={exportStudentsLoading}
                            onClick={handleExportStudents}
                        >
                            Öğrenci Çıktı Listesi
                        </Button>

                        <Button
                            type="primary"
                            style={{backgroundColor: "#13c2c2", border: "none"}}
                            loading={exportPaymentsLoading}
                            onClick={handleExportPayments}
                        >
                            Ödeme Yapanlar Listesi
                        </Button>

                        <Button
                            type="primary"
                            style={{backgroundColor: "#1677ff", border: "none"}}
                            onClick={() => setIsBulkModalVisible(true)}
                        >
                            Toplu Paket Ekle
                        </Button>

                        <Button
                            type="primary"
                            style={{backgroundColor: "#52c41a", border: "none"}}
                            onClick={() => setShowPaid(v => !v)}
                        >
                            Paid Total
                        </Button>

                        <Button
                            type="primary"
                            style={{backgroundColor: "#9e0c48", border: "none"}}
                            onClick={showFilterDrawer}
                        >
                            Filter
                        </Button>
                    </Flex>
                }
            >
                {loading ? (
                    <StyledLoad>
                        <Loader size={"sm"} />
                    </StyledLoad>
                ) : (
                    <Table
                        pagination={false}
                        columns={columns}
                        dataSource={students}
                        rowClassName={(record) => record.price ? 'row-paid' : ''}
                    />
                )}
                {students.length > 0 && (
                    <Pagination
                        defaultCurrent={pageNumber}
                        total={totalRecord}
                        onChange={onUserPageChange}
                        pageSizeOptions={[10, 10000]}
                        showSizeChanger={false}
                    />
                )}
            </Card>

            {studentDetail ? (
                <DetailModal
                    student={studentDetail}
                    visibleCallback={showDetailModal}
                />
            ) : null}

            {plan ? (
                <PlansModal plan={plan} visiblePlanCallback={showPlanModal}/>
            ) : null}

            {extramin ? (
                <Extramin
                    extramin={extramin}
                    visibleExtraMinCallback={showExtraMinModal}
                />
            ) : null}

            {payment ? (
                <AddPackage
                    payment={payment}
                    visiblePlanCallback={showTestModal}
                    isPlanModalVisible={isPlanModalVisible}
                    setIsPlanModalVisible={setIsPlanModalVisible}
                    getUserList={getUserList}

                />
            ) : null}

            <BulkAddPackage
                isBulkModalVisible={isBulkModalVisible}
                setIsBulkModalVisible={setIsBulkModalVisible}
                getUserList={getUserList}
            />

            {subscriptionList ? (
                <Subscription
                    subscriptionList={subscriptionList}
                    visiblePlanCallback={showSubscriptionModal}
                    setSubscriptionModal={setSubscriptionModal}
                    subscriptionModal={subscriptionModal}
                />
            ) : null}


            {creditList ? (
                <CreditStatus
                    creditList={creditList}
                    visiblePlanCallback={showCreditModal}
                    setCreditModal={setCreditModal}
                    creditModal={creditModal}
                    getUserList={getUserList}
                />
            ) : null}

            {/* Account Edit Modal */}
            <Modal
                title={accountStudent ? `${accountStudent.first_name} ${accountStudent.last_name} — Edit account` : 'Edit account'}
                open={accountModal}
                onOk={handleAccountSave}
                onCancel={() => setAccountModal(false)}
                confirmLoading={accountLoading}
                okText="Save"
                cancelText="Cancel"
                width={420}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                    <div>
                        <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Status</label>
                        <Select
                            style={{ width: '100%' }}
                            value={accountStatus}
                            onChange={(val) => setAccountStatus(val)}
                            options={[
                                { value: 1, label: 'Active' },
                                { value: 2, label: 'Passive' },
                                { value: 3, label: 'Deleted' },
                            ]}
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Email</label>
                        <Input
                            placeholder="Email address"
                            value={accountEmail}
                            onChange={(e) => setAccountEmail(e.target.value)}
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Login type</label>
                        <Select
                            style={{ width: '100%' }}
                            value={accountLoginType}
                            onChange={(val) => { setAccountLoginType(val); setAccountPassword(''); }}
                            disabled={!accountStudent?.social_type}
                            options={[
                                { value: 'google', label: 'Google' },
                                { value: 'apple', label: 'Apple' },
                                { value: 'normal', label: 'Email & password' },
                            ]}
                        />
                        {!accountStudent?.social_type && (
                            <small style={{ color: '#999' }}>Email login cannot be converted to social login</small>
                        )}
                    </div>
                    {/* When social account: show password if switching to normal */}
                    {accountStudent?.social_type && accountLoginType === 'normal' && (
                        <div>
                            <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>New password</label>
                            <Input.Password
                                placeholder="At least 6 characters"
                                value={accountPassword}
                                onChange={(e) => setAccountPassword(e.target.value)}
                            />
                            <small style={{ color: '#999' }}>Set a password to switch from social to email login</small>
                        </div>
                    )}
                    {/* Non-social: password can be changed directly */}
                    {!accountStudent?.social_type && (
                        <div>
                            <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Password</label>
                            <Input.Password
                                placeholder="New password (min 6 characters)"
                                value={accountPassword}
                                onChange={(e) => setAccountPassword(e.target.value)}
                            />
                        </div>
                    )}
                </div>
            </Modal>

        </>
    );
};


const GlobalStyle = createGlobalStyle`
  .row-paid td {
    font-weight: 700 !important;
  }
`

const Dropdowned = styled(Dropdown)`
  .rs-dropdown-item {
    display: flex;
    align-items: center;
    gap: 6px;
  }
`

const StyledLoad = styled.div`
    position: absolute;
    left: 50%;
    top: 200%;
    transform: translate(-50%,-50%);
`

export default Students;
